import * as React from 'react'

import { createContext } from '~logic/lib/react'

import { useLoadLockedOrder } from '../hooks/useLoadLockedOrder'

type TLockedOrder = ReturnType<typeof useLoadLockedOrder>

const [Provider, useLockedOrderCtx] = createContext<TLockedOrder>(`LockedOrder`)

type TProps = RequiredChildren & {
  orderId: ID
}

/**
 * Context provider of the OrderLockedScreen:
 * - use `useLockedOrder` to obtain the order.
 * - Provides:
 *    - the information needed to query the available payment methods,
 *    - the branch phone.
 *
 * ! Context value can be `null`.
 */
export const LockedOrderProvider: React.FC<TProps> = ({ orderId, children }) => {
  const order = useLoadLockedOrder({ orderId })

  return <Provider value={order}>{children}</Provider>
}

export { useLockedOrderCtx }
